import { IconSize } from '../../Icons/IconWrap';
export default function useIconSizeForButtonSize(buttonSize) {
    switch(buttonSize){
        case 'small':
            return IconSize.SMALLER;
        case 'medium':
            return IconSize.SMALLER;
        default:
            return IconSize.MEDIUM;
    }
}

//# sourceMappingURL=useIconSizeForButtonSize.js.map